import { Button, Form } from "react-bootstrap";

const UpdateMesageForm = ({ handleChange, handleSubmit, value }) => {
  return (
    <Form onSubmit={handleSubmit}>
      <Form.Control onChange={handleChange} type="text" value={value} />

      <div className="text-center m-2">
        <Button type="submit">ບັນທຶກ</Button>
      </div>
    </Form>
  );
};

export default UpdateMesageForm;
